import gql from 'graphql-tag'

export { TourFields as ITour } from './__generated__/TourFields'

export interface ITourParams {
  beginsAt: string
  endsAt: string
  childIds: number[]
}

export const TourFieldsFragment = gql`
  fragment TourFields on Tour {
    id
    schoolId
    beginsAt
    endsAt
    wasAttended
  }
`
